export const CREATE_FROM_TEMPLATE_IDB_KEY = 'create-from-template';
